import React,{Fragment} from 'react'

 
class CopyLabel extends React.Component{



 	render() {

   	
   	switch (this.props.label) {
     
     case 'heroTitle':
     return(
      <Fragment>
        Formative assessment has never been faster.
      </Fragment>
		 )

     case 'heroSub1':
     return (
      <Fragment>
        Plickers is the free card activity your students will love.
      </Fragment>
     )

     case 'heroSub2':
     return (
      <Fragment>
        Join millions and play in your next lesson.
      </Fragment>
     )

     case 'primarySignUp':
     return (
      <Fragment>
        Sign up for free
      </Fragment>
     )

     

     case 'primarySignUpSub':
     return (
      <Fragment>
        Used by K-12 teachers in over 100 countries
      </Fragment>
     )

    case 'primarySignUpiPad':
     return (
      <Fragment>
        Download iPad App
      </Fragment>
     )
     case 'primarySignUpiPhone':
     return (
      <Fragment>
        Download iPhone App
      </Fragment>
     )

     case 'primarySignUpAndroid':
     return (
      <Fragment>
        Download Android App
      </Fragment>
     )

     case 'phoneStatsiOS':
     return (
      <Fragment>
        4.9 rating from over 800 reviews <br/> on the App Store
      </Fragment>
     )

     case 'phoneStatsAndroid':
     return (
      <Fragment>
        Over 1,000 5 star reviews <br/> on the Google Play Store
      </Fragment>
     )

    case 'headerSignIn':
    return (
      <Fragment>
        Sign in
      </Fragment>
     )

    case 'headerSignUp':
    return (
      <Fragment>
        Get Started
      </Fragment>
     )

    default:
        return null;    

  
  }}}
   

export default CopyLabel
